var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-box"},[_c('div',[_vm._v(_vm._s(_vm.currentH)+" "+_vm._s(_vm.currentW))]),_vm._v(" "+_vm._s(_vm.currentD)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }